'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

import { HeaderOracles } from '../OraclesMarket'

const OraclesMarketError = () => {
  return (
    <div className="gap-2xs flex w-full flex-col">
      <HeaderOracles />
      <ErrorDataUnavailable minHeight="132px" />
    </div>
  )
}

export default memo(OraclesMarketError)
